// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { PolicyDetailsFacadeService } from '@app/access-management/state/policy-details/policy-details.facade';
import { PolicyDraft } from './../../../../../../core/models/index';
import { Component, OnInit } from '@angular/core';
import { selectPolicyStatementSelections, selectPolicyDraft, ClearPolicyFormAction } from '@app/access-management/state';
import { select, Store } from '@ngrx/store';
import { AlertService } from '@app/core/services/alert.service';
import { switchMap, take } from 'rxjs/operators';
import { PolicyService, GoAction, CreateStatementRequest, readParameterFromRouterState } from '@app/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-policy-statement-edit',
    templateUrl: './policy-statement-edit.component.html'
})
export class PolicyStatementEditComponent implements OnInit {
    statementSelections$: any;
    policyId: string;
    constructor(
        private store: Store<any>,
        private alertService: AlertService,
        private policyDetailsFacadeService: PolicyDetailsFacadeService,
        private route: ActivatedRoute,
        private policyService: PolicyService
        ) {

        const policyId = readParameterFromRouterState(this.route, 'id');
        if (!policyId) {
          throw new Error('role id not in route');
        }
        this.policyId = policyId;
        }

    ngOnInit(): void {
        this.statementSelections$ = this.store.pipe(select(selectPolicyStatementSelections));
    }
    trackByStatementIdx(idx: number) {
        return `statement${idx}`;
    }

    createStatementRequest (selectedPolicy: PolicyDraft) {
        const policy = selectedPolicy.statements[0];
        const request: CreateStatementRequest = {
            statement_id: policy.statement_id,
            effect: policy.effect,
            resource_id: policy.resource_id,
            actions: policy.actions
        };
        return request;
    }

    submit () {

        this.store.pipe(
            take(1),
            select(selectPolicyDraft),
            switchMap(policyDraft => this.policyService
                    .updateStatement(this.policyId, this.createStatementRequest(policyDraft))))
        .subscribe(() => {
            this.store.dispatch(new ClearPolicyFormAction());
            this.store.dispatch(new GoAction(['/iam/policies', this.policyId]));
            // this.store.dispatch(new LoadingPolicyAction());
            this.alertService.success('Statement has successfully been updated.');
            this.policyDetailsFacadeService.refreshPolicyDetails(this.policyId);
        }, () => {
            this.alertService.error('Statement update has failed.');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policy-details/policy-statements-list/policy-statement-edit/policy-statement-edit.component.ts